import axios from 'axios';

/**
 * Common API service for activity-related operations
 */
export const activityApiService = {
  /**
   * Save activity completion data
   * @param {Object} data - Activity data
   * @returns {Promise} API response
   */
  saveActivity: async (data) => {
    return await axios.post(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveActivity`,
      data
    );
  },

  /**
   * Save individual question response
   * @param {Object} data - Question response data
   * @returns {Promise} API response
   */
  saveActivityQuestion: async (data) => {
    return await axios.post(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveActivityQuestion`,
      data
    );
  },

  /**
   * Delete activity questions for a student
   * @param {Object} data - Delete data
   * @returns {Promise} API response
   */
  deleteActivityQuestions: async (data) => {
    return await axios.post(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/deleteActivityQuestions`,
      data
    );
  },

  /**
   * Get activity questions
   * @param {string} activityId - Activity ID
   * @returns {Promise} API response
   */
  getActivityQuestions: async (activityId) => {
    return await axios.get(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getActivityQuestions/${activityId}`
    );
  },

  /**
   * Get activity link
   * @param {string} activityId - Activity ID
   * @returns {Promise} API response
   */
  getActivityLink: async (activityId) => {
    return await axios.get(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getActivityLink/${activityId}`
    );
  },

  /**
   * Get activity time
   * @param {string} activityId - Activity ID
   * @returns {Promise} API response
   */
  getActivityTime: async (activityId) => {
    return await axios.get(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getActivityTime/${activityId}`
    );
  },

  /**
   * Get student ID from user
   * @param {string} userId - User ID
   * @returns {Promise} API response
   */
  getStudentIdFromUser: async (userId) => {
    return await axios.post(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentIDfromUser`,
      { UserId: userId }
    );
  },

  /**
   * Submit complete activity response
   * @param {Object} data - Complete response data
   * @returns {Promise} API response
   */
  submitCompleteActivityResponse: async (data) => {
    return await axios.post(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/submitCompleteActivityResponse`,
      data
    );
  }
};
